var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMyVets(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#F0F2FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1656_1489)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.75 29.2499C12.7508 28.134 13.028 27.0356 13.5571 26.0531C14.0861 25.0705 14.8503 24.2344 15.7815 23.6195C16.7127 23.0045 17.7817 22.6299 18.893 22.5291C20.0044 22.4283 21.1234 22.6045 22.15 23.0419",
    stroke: "#1429B8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9453 14.7808C16.5842 15.4432 17.35 15.97 18.1971 16.3298C19.0441 16.6895 19.955 16.8749 20.8753 16.8748C21.8079 16.8755 22.7308 16.6856 23.5873 16.3168",
    stroke: "#1429B8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.375 16.875C15.375 17.969 15.8096 19.0182 16.5832 19.7918C17.3568 20.5654 18.406 21 19.5 21C20.594 21 21.6432 20.5654 22.4168 19.7918C23.1904 19.0182 23.625 17.969 23.625 16.875C23.625 15.781 23.1904 14.7318 22.4168 13.9582C21.6432 13.1846 20.594 12.75 19.5 12.75C18.406 12.75 17.3568 13.1846 16.5832 13.9582C15.8096 14.7318 15.375 15.781 15.375 16.875Z",
    stroke: "#1429B8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.25 26.25H34.25C34.25 26.25 35.25 26.25 35.25 27.25V34.25C35.25 34.25 35.25 35.25 34.25 35.25H24.25C24.25 35.25 23.25 35.25 23.25 34.25V27.25C23.25 27.25 23.25 26.25 24.25 26.25Z",
    stroke: "#1429B8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 23.25H30.5C30.7652 23.25 31.0196 23.3554 31.2071 23.5429C31.3946 23.7304 31.5 23.9848 31.5 24.25V26.25H27V24.25C27 23.9848 27.1054 23.7304 27.2929 23.5429C27.4804 23.3554 27.7348 23.25 28 23.25Z",
    stroke: "#1429B8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.25 29.25V32.25",
    stroke: "#1429B8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.75 30.75H30.75",
    stroke: "#1429B8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1656_1489"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyVets);
export default __webpack_public_path__ + "static/media/my-vets.ed48eb500b2089baf5bb91ee35ea1429.svg";
export { ForwardRef as ReactComponent };